export default "__VITE_ASSET__CAUrSHxM__"